import {
  IconFileInvoice,
  IconBox,
  IconBriefcase,
} from "@tabler/icons-react";
import GrInvoiceAutomationPage from "../pages/modules/grInvoiceAutomation/index.jsx";
import ApWorkbenchPage from "../pages/modules/apWorkbench/index.jsx";

/**
 * Frontend module registry — mirrors backend `config/modules.js` by `key`.
 * Each entry binds a module key to its React page component and an icon.
 *
 * When adding a new module:
 *   1. Add it to the backend registry first.
 *   2. Create the page component under `pages/modules/`.
 *   3. Register the mapping here.
 */
const ICONS = {
  IconFileInvoice,
  IconBriefcase,
};

export const MODULE_COMPONENTS = {
  "gr-invoice-automation": GrInvoiceAutomationPage,
  "ap-workbench": ApWorkbenchPage,
};

export function getModuleIcon(name) {
  return ICONS[name] || IconBox;
}

export function getModuleComponent(key) {
  return MODULE_COMPONENTS[key] || null;
}
